import { useState } from "react";
import { ShieldCheck } from "lucide-react";
import { Button } from "./ui/button";

const KEY = "natur_consent";
const CATS = [
  { id: "analytics", label: "Analítica" },
  { id: "marketing", label: "Marketing" },
  { id: "personalization", label: "Personalización" },
  { id: "thirdparty", label: "Terceros" },
];

export default function CookieConsent() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(KEY));
  const [prefs, setPrefs] = useState({ analytics: false, marketing: false, personalization: false, thirdparty: false });
  const [expanded, setExpanded] = useState(false);

  if (!visible) return null;

  const save = (p) => {
    localStorage.setItem(KEY, JSON.stringify({ necessary: true, ...p, ts: new Date().toISOString() }));
    setVisible(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40 px-4" data-testid="cookie-banner">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-xl overflow-hidden">
        <div className="p-6 sm:p-8">
          <h2 className="flex items-center gap-2 text-lg font-semibold mb-3">
            <ShieldCheck size={20} className="text-emerald-500" /> Su privacidad nos importa
          </h2>
          <p className="text-sm text-neutral-600 mb-4">
            Utilizamos cookies y servicios digitales propios y de terceros para el funcionamiento de la
            plataforma, analítica, marketing y personalización. Puede aceptar todo, rechazar las categorías
            opcionales o configurar sus preferencias.
          </p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 mb-5 text-sm">
            <label className="flex items-center gap-1.5 text-neutral-400">
              <input type="checkbox" checked disabled /> <span className="font-medium">Necesarias</span>
            </label>
            {CATS.map((c) => (
              <label key={c.id} className="flex items-center gap-1.5 cursor-pointer">
                <input type="checkbox" checked={prefs[c.id]} data-testid={`cookie-cat-${c.id}`}
                       onChange={(e) => setPrefs({ ...prefs, [c.id]: e.target.checked })} />
                <span className="font-medium">{c.label}</span>
              </label>
            ))}
          </div>
          <Button onClick={() => save({ analytics: true, marketing: true, personalization: true, thirdparty: true })}
                  data-testid="cookie-accept-all"
                  className="w-full h-11 rounded-xl bg-amber-400 hover:bg-amber-500 text-neutral-900 font-semibold">
            Aceptar todo
          </Button>
          <div className="flex justify-center gap-6 mt-4 text-xs font-medium">
            <button onClick={() => save({ analytics: false, marketing: false, personalization: false, thirdparty: false })}
                    data-testid="cookie-reject" className="underline text-neutral-600 hover:text-neutral-900">
              Continuar sin consentimiento
            </button>
            <button onClick={() => (expanded ? save(prefs) : setExpanded(true))} data-testid="cookie-custom"
                    className="underline text-neutral-600 hover:text-neutral-900">
              {expanded ? "Guardar mis preferencias" : "Ajustes individuales"}
            </button>
          </div>
        </div>
        <div className="bg-neutral-50 border-t border-neutral-100 px-6 py-3 flex justify-center gap-5 text-[11px] text-neutral-400">
          <a href="https://naturautoescuela.es/politica-de-cookies" target="_blank" rel="noreferrer" className="hover:text-neutral-600">Política de Cookies</a>
          <a href="https://naturautoescuela.es/aviso-legal" target="_blank" rel="noreferrer" className="hover:text-neutral-600">Aviso Legal</a>
          <a href="https://naturautoescuela.es" target="_blank" rel="noreferrer" className="hover:text-neutral-600">Área Legal</a>
        </div>
      </div>
    </div>
  );
}
